import axios, { AxiosInstance } from 'axios'
import { AVAILY_API_URLS, CLINIC_SERVICE_URLS, Environment, GAP_FILLER_URLS, MEDPRESS_API_URLS } from 'src/lib'
import getEnv, { ENV_VARIABLES, isProduction } from 'src/config'

export const publicClient: AxiosInstance = axios.create({
  baseURL: `${getEnv(ENV_VARIABLES.API_BASE_URL)}/api/v1/public`,
})

export const gapFillerClient: AxiosInstance = axios.create({
  baseURL: isProduction() ? GAP_FILLER_URLS.PRODUCTION : GAP_FILLER_URLS.STAGING,
})

export const clinicServiceClient: AxiosInstance = axios.create({
  baseURL: isProduction() ? CLINIC_SERVICE_URLS.PRODUCTION : CLINIC_SERVICE_URLS.STAGING,
})

export const medpressClient: AxiosInstance = axios.create({
  baseURL: isProduction() ? MEDPRESS_API_URLS.PRODUCTION : MEDPRESS_API_URLS.STAGING,
})

export const updateBaseUrl = (env: Environment) => {
  if (env === Environment.Production) {
    publicClient.defaults.baseURL = AVAILY_API_URLS.PUBLIC_CLIENT_PRODUCTION
    gapFillerClient.defaults.baseURL = GAP_FILLER_URLS.PRODUCTION
    clinicServiceClient.defaults.baseURL = CLINIC_SERVICE_URLS.PRODUCTION
    medpressClient.defaults.baseURL = MEDPRESS_API_URLS.PRODUCTION
  } else {
    publicClient.defaults.baseURL = AVAILY_API_URLS.PUBLIC_CLIENT_STAGING
    gapFillerClient.defaults.baseURL = GAP_FILLER_URLS.STAGING
    clinicServiceClient.defaults.baseURL = CLINIC_SERVICE_URLS.STAGING
    medpressClient.defaults.baseURL = MEDPRESS_API_URLS.STAGING
  }
}
